import ISendFeedbackDTO from "@models/DTO/ISendFeedbackDTO";
import IUserUI from "@models/IUserUI";
import ISupplierModel from "@models/ISupplierModel";
import IVendorModel from "@models/IVendorModel";
import SocketService from "./SocketService";
import { buildAuthHeadersForFetch } from "./RestService";

/**
 * POST /user/feedback — the API's generic feedback mailer (ISendFeedbackDTO).
 * The route is not in the synced RestEndpointsEnum, so the path lives here.
 */
const FEEDBACK_PATH = "/user/feedback";

export const FEEDBACK_SOURCE_FILTER_BAR = "filter_bar_v2";

const sendFeedback = async (
    feedback: string,
    source: string,
    models: { userModel: IUserUI; supplierModel: ISupplierModel; vendorModel?: IVendorModel }
): Promise<void> => {
    const payload: ISendFeedbackDTO = {
        userGuid: models.userModel.guid,
        userName: models.userModel.name,
        userEmail: models.userModel.email,
        feedback,
        source,
    };

    const response = await fetch(`${SocketService.getEndpointUrl()}${FEEDBACK_PATH}`, {
        method: "POST",
        headers: buildAuthHeadersForFetch(models),
        body: JSON.stringify(payload),
    });

    if (!response.ok) {
        throw new Error(`Failed to send feedback: ${response.statusText}`);
    }
};

const FeedbackService = {
    sendFeedback,
};

export default FeedbackService;
